import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Tooltip } from '@material-ui/core';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import UserContext from 'components/context/UserContext';
import {
    companyDomainEmailTooltip,
    isCompanyDomainEmail,
} from 'utils/customer/CompanyDomainEmail';

const useStyles = makeStyles((theme) => ({
    emailCell: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: theme.spacing(0.5),
    },
    emailWarningIconWrapper: {
        display: 'flex',
        alignItems: 'center',
        lineHeight: 0,
    },
    emailWarningIcon: {
        color: theme.palette.warning.main,
        fontSize: 18,
    },
}));

const CompanyDomainEmailCell = ({ email }) => {
    const classes = useStyles();
    const { userInformation = {} } = useContext(UserContext);
    const showWarning = isCompanyDomainEmail(email, userInformation.companyListDomain);

    if (!email) return '-';

    return (
        <span className={classes.emailCell}>
            {email}
            {showWarning && (
                <Tooltip title={companyDomainEmailTooltip} placement="top">
                    <span className={classes.emailWarningIconWrapper}>
                        <WarningRoundedIcon className={classes.emailWarningIcon} />
                    </span>
                </Tooltip>
            )}
        </span>
    );
};

CompanyDomainEmailCell.propTypes = {
    email: PropTypes.string,
};

CompanyDomainEmailCell.defaultProps = {
    email: '',
};

export default CompanyDomainEmailCell;
